<DataGridView DataUrl="/Backend/Api/V2/Admin/Leitstelle/List" #Grid KeyProperty="key">
  <DataGridViewColumn field="name" header="Name" />
  <DataGridViewColumn field="mail" header="E-Mail" />
  <DataGridViewColumn field="telefone" header="Telefone" />
  <DataGridViewColumn field="ansprechPartner" header="Ansprech Partner" />
  <DataGridViewColumn [isFixed]="true"  [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>
      <PopUpView icon="bi bi-pencil-fill" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-primary" header="Leitsetlle">
        <ng-template #staticContent>
          <LeitsetlleEdit [Key]="row?.key"></LeitsetlleEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
    <ng-template #header>
      <PopUpView icon="bi bi-plus" (PopupClosed)="triggerReload()" btnClass="btn-sm btn-success" header="Leitsetlle">
        <ng-template #staticContent>
          <LeitsetlleEdit></LeitsetlleEdit>
        </ng-template>
      </PopUpView>
    </ng-template>
  </DataGridViewColumn>
</DataGridView>
